<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.52 11.42A3.48 3.48 0 0 0 12 5.5a3.5 3.5 0 0 0-2.52 5.92A3.98 3.98 0 0 0 12 18.5a3.98 3.98 0 0 0 2.52-7.08M10.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5 7.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4M12 0a12.01 12.01 0 1 0 12 12c0-6.62-5.38-12-12-12m0 22a10.01 10.01 0 0 1 0-20 10.01 10.01 0 0 1 0 20"/></svg>
</template>
